import React from "react"

export default function PenaltyReadState({ request, label, errorMessage, children }) {
  if (request.loading) return <p role="status">Loading {label}…</p>
  if (request.error || !request.data) return <div className="alert alert-warning" role="alert">{errorMessage || `The ${label} could not be loaded.`} <button className="btn btn-light btn-sm" onClick={request.reload}>Retry {label}</button></div>
  return children || null
}
